'use strict';

var _ = require('lodash');
var MarketGridsUtilsService = function MarketGridsUtilsService(SearchRule, configurationService) {
  function compareRulesArray(ruleArray, otherRuleArray) {
    return _.every(ruleArray, function (item, index) {
      return item.isEqual(otherRuleArray[index]);
    });
  }
  function searchRulesEqual(ruleArray, otherRuleArray) {
    if (ruleArray.length !== otherRuleArray.length) {
      return false;
    } else {
      return compareRulesArray(ruleArray, otherRuleArray);
    }
  }
  function createRule(metaCategory, field, operator, leftOperand, rightOperand) {
    return new SearchRule({
      metaCategory: metaCategory,
      field: field,
      operator: operator,
      leftOperand: leftOperand,
      rightOperand: rightOperand
    });
  }
  function cabinsClassesToProductGroups(cabinsClassesMarket) {
    var classGroupConfig = configurationService.getClassGroupConfigByMarket(cabinsClassesMarket.market);
    var classesDefined = !_.isEmpty(cabinsClassesMarket.classes);
    return _.chain(classGroupConfig).filter(function (c) {
      return classesDefined && cabinsClassesMarket.classes.indexOf(c.className) !== -1 || !classesDefined && cabinsClassesMarket.cabins.indexOf(c.cabinCode) !== -1;
    }).map('classGroup').uniq().value();
  }
  return {
    createRule: createRule,
    searchRulesEqual: searchRulesEqual,
    cabinsClassesToProductGroups: cabinsClassesToProductGroups
  };
};
MarketGridsUtilsService.$inject = ['SearchCriteriaRuleFactory', 'ConfigurationService'];
module.exports = MarketGridsUtilsService;